import { render, staticRenderFns } from "./CommonHAWB.vue?vue&type=template&id=621ec3ae&"
import script from "./CommonHAWB.vue?vue&type=script&lang=js&"
export * from "./CommonHAWB.vue?vue&type=script&lang=js&"
import style0 from "./CommonHAWB.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('621ec3ae')) {
      api.createRecord('621ec3ae', component.options)
    } else {
      api.reload('621ec3ae', component.options)
    }
    module.hot.accept("./CommonHAWB.vue?vue&type=template&id=621ec3ae&", function () {
      api.rerender('621ec3ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirImport/components/booking/tabs/CommonHAWB.vue"
export default component.exports